export default __webpack_public_path__ + "static/media/mobile_banner_claim.87f6adef.jpg";